import { useEffect, useState } from "react";
import { CognitoUserPool } from "amazon-cognito-identity-js";

const useSessionCognito = ()=>{
  const [expiredSession, setExperidSession] = useState(false);
  const [loading, setLoading] = useState(false);
  function getUserSession() {
      setLoading(true);
      const USER_POOL_CONFIG = {
        UserPoolId: process.env.REACT_APP_USER_POOL_ID,
        ClientId: process.env.REACT_APP_APP_CLIENT_ID,
      };
      const userPool = new CognitoUserPool(USER_POOL_CONFIG);
      const cognitoUser = userPool.getCurrentUser();
      if (cognitoUser !== null) {
        try {
          cognitoUser.getSession((err, session) => {
            if (err) {
              setExperidSession(true);
              return false;
            }
            if (session === null ) {
              setExperidSession(true);
              setLoading(false);
              return false;
            }
          });
        } catch (e) {
          setExperidSession(true);
          setLoading(false);
        }
      } else {
        const cognito = userPool.getCurrentUser();
        if (cognito !== null) {
          setLoading(false);
          setExperidSession(true);
          cognito.signOut();
        }
      }
  }
  useEffect(() => {
    const fetchSession = setInterval(() => {
      return getUserSession();
    },65 * 60 * 1000);
    getUserSession();
    return () => {
      clearInterval(fetchSession);
    };
  }, [loading]);
  return expiredSession;
};
export default useSessionCognito;